module.exports = __webpack_public_path__ + "img/welcome.fc68b201.gif";